import styled from 'styled-components'
export const Main =  styled.div`
display:flex ;
width:100% ;
${'' /* height:100vh ; */}
margin:2rem auto;
justify-content:space-between ;

align-items:center ;

`